import { render, staticRenderFns } from "./staffDataDetail.vue?vue&type=template&id=051e2b5e&scoped=true&"
import script from "./staffDataDetail.vue?vue&type=script&lang=js&"
export * from "./staffDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e2b5e",
  null
  
)

export default component.exports